module.exports = __webpack_public_path__ + "static/media/tablet_order_notification_sound.532b61be.mp3";